module.exports = __webpack_public_path__ + "static/img/Skinport_bot.5eb63ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/Skinport_bot.jpg
// module id = vT05
// module chunks = 1